import { ReactNode } from 'react';
import useGoToConfirmationPageIfAlreadyPurchased from 'src/helpers/hooks/useGoToConfirmationPageIfAlreadyPurchased';

interface PurchasedRedirectGuardProps {
  children: ReactNode;
}

/**
 * Redirects to already purchased page if renter has already purchased the policy
 */
export function PurchaseFlowAlreadyPurchasedGuard({ children }: PurchasedRedirectGuardProps) {
  useGoToConfirmationPageIfAlreadyPurchased();

  return <>{children}</>;
}
